import * as React from "react";

function IconCalendar(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.417 2.333h-1.359V1.5a.833.833 0 10-1.666 0v.833H6.608V1.5a.833.833 0 10-1.666 0v.833H3.583A1.667 1.667 0 001.917 4v12.833A1.667 1.667 0 003.583 18.5h12.834a1.667 1.667 0 001.666-1.667V4a1.667 1.667 0 00-1.666-1.667zM10 13a1 1 0 000 2h5a1 1 0 100-2h-5z"
        fill="#989BA2"
      />
    </svg>
  );
}

const MemoIconCalendar = React.memo(IconCalendar);
export default MemoIconCalendar;
